// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "large-Ljo2";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "link-z3ay";
var _8 = "medium-NJ5T";
var _9 = "1rem";
var _a = "#bebebe";
var _b = "small-cCxF";
var _c = ".8rem";
var _d = "transitTypeIcon-bqiF";
var _e = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "large", _5 as "lightGrey", _6 as "lightblue", _7 as "link", _8 as "medium", _9 as "mediumFontSize", _a as "mediumLightGrey", _b as "small", _c as "smallFontSize", _d as "transitTypeIcon", _e as "unusedNodeColor" }
